

import React from "react";
import "./Pm_Parivar.css";
import { Container, Row, Col } from "react-bootstrap";

const Pm_Parivar = () => {
  return (
    <section className="parivar-section">
      <Container>
        <Row>
          <Col lg={12}>
            <div className="section-title"></div>

            <Row className="text_holder">
              <Col lg={4} xs={12} className="order-1 order-lg-1">
                <div className="image_holder">
                  <img
                    src="/assets/images/about_us/vaghani.png"
                    alt="vaghani-img"
                    className="vaghani_img"
                  />
                  <h2 className="image_title">Shree P. M. Vaghani Sir</h2>
                  <h4 className="image_desc">Chairman Shree</h4>
                </div>
              </Col>

              <Col lg={8} xs={12} className="order-2 order-lg-2">
                <div className="section_text">
                  <p className="text">
                    Beside all such innovative activities I am actively
                    associated with farmers. Organic farming is one of the vital
                    issues and I regularly visit the village area of Saurashtra
                    to hold meetings with farmers and convince them about
                    organic farming. On the other hand I visited all the metro
                    cities of India for promoting my business of Patel AtoZ
                    Agency. I also visited Nepal and Sri Lanka with same
                    purpose. The “Srishti Sansthan” of Ahmedabad organises
                    “ShodhYatra” every year and I have actively participated in
                    many yatras.
                  </p>

                  <p className="text">
                    In 2002 there was a “National Science Fair” in Pune & I
                    presented my “Bestow Agriculture Spray Pump”, former Prime
                    minister Shree Atal Bihari Bajpayeeji visited my stall and
                    appreciated my work. I was also honoured by “Agriculture
                    University Navsari & Junagadh” for innovative work in
                    agriculture field.
                  </p>

                  <p className="text">
                    During Shodh Yatras I met many innovators contacted them and
                    exchanged many innovative ideas. There was a Sammelan for
                    all the innovators was organized in Ahmedabad and chaired by
                    the Honorable President of India. In this seminar Dr. A.P.J.
                    Abdul Kalam many innovators were honoured, I was one of
                    them. In Jasdan, district Rajkot “SarvDharm Samuh lagan
                    Samaroh”, Prime was organized presided by honorable Minister
                    Shri Narender Modi, in this function 351 pairs were married,
                    these 351 married couples made a human map of Gujarat. Each
                    couple was married by his customs from every religion, caste
                    couples were invited, and in this function I was personally
                    appreciated and honored by our Chief Coordinator, Prime
                    Minister.
                  </p>

                  <p className="text">
                    I dedicated my knowledge as a Guest Lecturer at IIM
                    Ahmedabad and various Agriculture Universities and
                    innovation units of India. I also invented three dozen
                    mankind machines like Magnetic Engine, Power Bank—these two
                    equipment don't need any type of external energy or fuel to
                    generate power or electricity.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Pm_Parivar;
